// // ============================================================================
// // IDEA 1: THE COLLAPSIBLE TREE (Recommended for large lineages)
// // ============================================================================
// import React, { useState } from 'react';
// import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

// // --- CSS: CONNECTORS + HOVER LOGIC ---
// const treeStyles = `
// /* 1. FLEX LAYOUT */
// .tree ul {
//     padding-top: 20px; 
//     position: relative;
//     transition: all 0.5s;
//     display: flex; 
//     justify-content: center;
// }

// .tree li {
//     float: left; text-align: center;
//     list-style-type: none;
//     position: relative;
//     padding: 20px 5px 0 5px;
//     transition: all 0.5s;
// }

// /* 2. CONNECTOR LINES (Dark Grey) */
// .tree li::before, .tree li::after {
//     content: ''; 
//     position: absolute; top: 0; right: 50%;
//     border-top: 2px solid #64748b; 
//     width: 50%; height: 20px; 
//     z-index: 0;
// }
// .tree li::after { 
//     right: auto; left: 50%; 
//     border-left: 2px solid #64748b; 
// }
// .tree li:only-child::after, .tree li:only-child::before { display: none; }
// .tree li:only-child { padding-top: 0; }
// .tree li:first-child::before, .tree li:last-child::after { border: 0 none; }
// .tree li:last-child::before { 
//     border-right: 2px solid #64748b; 
//     border-radius: 0 5px 0 0; 
// }
// .tree li:first-child::after { 
//     border-radius: 5px 0 0 0; 
// }
// .tree ul ul::before {
//     content: ''; 
//     position: absolute; top: 0; left: 50%;
//     border-left: 2px solid #64748b; 
//     width: 0; height: 20px;
// }

// /* 3. HOVER LOGIC FOR BIO TOOLTIP */
// .member-card .bio-tooltip {
//     visibility: hidden;
//     opacity: 0;
//     transition: opacity 0.2s ease-in-out;
// }
// .member-card:hover .bio-tooltip {
//     visibility: visible;
//     opacity: 1;
// }

// /* 4. ADMIN ACTIONS VISIBILITY */
// .member-card .admin-actions {
//     opacity: 0;
//     transition: opacity 0.2s;
// }
// .member-card:hover .admin-actions {
//     opacity: 1;
// }
// `;

// const FamilyTree = ({ members = [], onAddMember, onEditMember, onDeleteMember, onRequestPhone, isAdmin }) => {

//   // --- NEW: COLLAPSIBLE STATE ---
//   const [collapsedState, setCollapsedState] = useState({});

//   if (!members || !Array.isArray(members)) {
//     return <div style={{padding: '40px', textAlign: 'center', color: '#666'}}>Loading Family Tree...</div>;
//   }

//   // --- LOGIC: BUILD TREE ---
//   const buildTree = () => {
//     try {
//       const memberMap = {};
//       members.forEach(m => { if (m && m.id) memberMap[m.id] = { ...m, children: [] }; });
      
//       const roots = [];
      
//       members.forEach(m => {
//         if (!m || !m.id) return;
//         const node = memberMap[m.id];
        
//         const father = m.fatherId ? memberMap[m.fatherId] : null;
//         const mother = m.motherId ? memberMap[m.motherId] : null;

//         if (father && mother) {
//              if (mother.fatherId || mother.motherId) mother.children.push(node);
//              else if (father.fatherId || father.motherId) father.children.push(node);
//              else father.children.push(node);
//         } else if (father) {
//              father.children.push(node);
//         } else if (mother) {
//              mother.children.push(node);
//         } else {
//             if (m.spouseId) {
//                  const spouse = memberMap[m.spouseId];
//                  if (!spouse) roots.push(node); 
//                  else if (!spouse.fatherId && !spouse.motherId) {
//                     if (m.gender === 'Male') roots.push(node);
//                  }
//             } else { roots.push(node); }
//         }
//       });
//       return roots;
//     } catch (err) { return []; }
//   };

//   const treeData = buildTree();

//   // --- COLLAPSE HANDLER ---
//   const toggleNode = (nodeId, currentDefaultState, e) => {
//     e.stopPropagation();
//     setCollapsedState(prev => ({
//         ...prev,
//         [nodeId]: prev[nodeId] === undefined ? !currentDefaultState : !prev[nodeId]
//     }));
//   };

//   // --- MEMBER CARD COMPONENT ---
//   const Member = ({ person, relation, isSpouse }) => {
//     if (!person) return null;
//     const isMale = person.gender === 'Male';
//     const cardStyle = {
//         backgroundColor: '#ffffff',
//         border: isMale ? '2px solid #60a5fa' : '2px solid #f472b6', 
//         borderRadius: '12px',
//         padding: '12px', width: '200px', minHeight: '160px',
//         boxShadow: '0 4px 6px rgba(0,0,0,0.1)', position: 'relative', display: 'flex', flexDirection: 'column',
//         alignItems: 'center', justifyContent: 'space-between', zIndex: 10, margin: '0 auto', cursor: 'default'
//     };

//     return (
//       <div className="member-card" style={cardStyle}>

//         {/* NEW: BIRTH ORDER BADGE */}
//         {person.birthOrder && (
//             <div style={{ position: 'absolute', top: '-12px', left: '-12px', backgroundColor: isMale ? '#2563eb' : '#db2777', color: 'white', fontSize: '12px', fontWeight: 'bold', width: '26px', height: '26px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 30, boxShadow: '0 2px 5px rgba(0,0,0,0.2)', border: '2px solid white' }}>
//                 {person.birthOrder}
//             </div>
//         )}

//         {person.bio && (
//             <div className="bio-tooltip" style={{
//                 position: 'absolute', bottom: '100%', left: '50%', transform: 'translateX(-50%)', marginBottom: '10px',
//                 width: '220px', padding: '12px', backgroundColor: '#1e293b', color: 'white', fontSize: '12px',
//                 borderRadius: '8px', boxShadow: '0 10px 15px rgba(0,0,0,0.2)', zIndex: 100, textAlign: 'left', pointerEvents: 'none'
//             }}>
//                 <div style={{ fontWeight: 'bold', borderBottom: '1px solid #475569', paddingBottom: '4px', marginBottom: '4px' }}>{person.name}</div>
//                 <p style={{ lineHeight: '1.4', opacity: 0.9, margin: 0 }}>{person.bio}</p>
//                 <div style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', borderWidth: '6px', borderStyle: 'solid', borderColor: '#1e293b transparent transparent transparent' }}></div>
//             </div>
//         )}

//         <div style={{ position: 'absolute', top: '-10px', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#475569', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '2px 8px', borderRadius: '12px', zIndex: 20 }}>
//             {relation}
//         </div>

//         <div style={{ width: '100%', textAlign: 'center', marginTop: '8px' }}>
//             <div style={{ fontWeight: 'bold', color: isMale ? '#1e3a8a' : '#831843', marginBottom: '4px', wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', lineHeight: '1.2', width: '100%', fontSize: '14px' }}>{person.name}</div>
//             <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: '4px', fontSize: '10px', fontWeight: 'bold', backgroundColor: isMale ? '#eff6ff' : '#fdf2f8', color: isMale ? '#2563eb' : '#db2777' }}>{person.gender}</span>
//             <div style={{ fontSize: '11px', color: '#64748b', marginTop: '6px' }}>
//                 <div style={{ whiteSpace: 'nowrap' }}>DOB {person.birthDate || '?'}</div>
//                 {person.deathDate && <div style={{ color: '#94a3b8' }}>D {person.deathDate}</div>}
//             </div>
//             {person.email && <div style={{ fontSize: '10px', color: '#64748b', marginTop: '4px', wordBreak: 'break-all' }} title={person.email}>📧 {person.email}</div>}
//             {person.website && <div style={{ fontSize: '10px', color: '#3b82f6', marginTop: '2px' }}>🔗 <a href={person.website} target="_blank" rel="noopener noreferrer" style={{color: 'inherit'}}>Website</a></div>}
//         </div>

//         <div style={{ width: '100%', marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #f1f5f9' }}>
//             {person.phoneNumber === 'HIDDEN' ? (
//                 <button onClick={(e) => { e.stopPropagation(); if(onRequestPhone) onRequestPhone(person); }} style={{ width: '100%', fontSize: '10px', fontWeight: 'bold', color: '#2563eb', backgroundColor: '#eff6ff', border: '1px solid #dbeafe', padding: '6px', borderRadius: '4px', cursor: 'pointer' }}>Request Contact</button>
//             ) : <div style={{ fontSize: '11px', color: '#475569' }}>📞 {person.phoneNumber || 'N/A'}</div>}
//         </div>

//         {(onAddMember || isAdmin) && (
//             <div className="admin-actions" style={{ display: 'flex', gap: '4px', justifyContent: 'center', marginTop: '6px' }}>
//                 {isAdmin ? (
//                     <>
//                         <button onClick={(e) => { e.stopPropagation(); onEditMember(person); }} style={{ fontSize: '10px', color: '#3b82f6', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>Edit</button>
//                         <button onClick={(e) => { e.stopPropagation(); if(window.confirm('Delete?')) onDeleteMember(person.id); }} style={{ fontSize: '10px', color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>Del</button>
//                     </>
//                 ) : null}
//                 {onAddMember && <button onClick={(e) => { e.stopPropagation(); onAddMember(person, 'child'); }} style={{ fontSize: '9px', backgroundColor: '#f1f5f9', border: '1px solid #cbd5e1', padding: '2px 6px', borderRadius: '4px', cursor: 'pointer' }}>+</button>}
//             </div>
//         )}
//       </div>
//     );
//   };

//   const renderTree = (nodes, depth = 0) => {
//     if (!nodes || nodes.length === 0) return null;
//     return (
//       <ul>
//         {nodes.map((node) => {
//             const spouse = node.spouseId ? members.find(m => m.id === node.spouseId) : null;
            
//             let primaryRelation = 'Head';
//             if (node.fatherId || node.motherId) primaryRelation = node.gender === 'Male' ? 'Son' : 'Daughter';
//             else if (spouse) primaryRelation = node.gender === 'Male' ? 'Husband' : 'Wife';
            
//             const marriageDate = node.marriageDate || (spouse ? spouse.marriageDate : null);
//             const hasChildren = node.children && node.children.length > 0;
            
//             // Default collapse nodes at depth 1 and below (so level 2+ is hidden)
//             const defaultCollapsed = depth >= 1; 
//             const isCollapsed = collapsedState[node.id] !== undefined ? collapsedState[node.id] : defaultCollapsed;

//             return (
//               <li key={node.id}>
//                 <div style={{ display: 'inline-block', verticalAlign: 'top', textAlign: 'center' }}>
                    
//                     {!node.fatherId && !node.motherId && onAddMember && (
//                         <div style={{ marginBottom: '20px' }}>
//                             <button onClick={(e) => { e.stopPropagation(); onAddMember(node, 'parent'); }} style={{ backgroundColor: '#334155', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '6px 16px', borderRadius: '20px', border: 'none', cursor: 'pointer' }}>{isAdmin ? '+ Add Parents' : 'Request Parents'}</button>
//                         </div>
//                     )}

//                     <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '0px' }}>
//                         <Member person={node} relation={primaryRelation} isSpouse={false} />
//                         {spouse && (
//                             <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 10px', paddingTop: '40px' }}>
//                                 <div style={{ position: 'absolute', top: '55px', width: '100%', height: '2px', backgroundColor: '#fda4af', zIndex: 0 }}></div>
//                                 <div style={{ backgroundColor: 'white', border: '1px solid #fecdd3', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#f43f5e', fontSize: '12px', zIndex: 10, marginBottom: '4px' }}>♥</div>
//                                 {marriageDate && <span style={{ fontSize: '9px', color: '#64748b', backgroundColor: 'white', padding: '2px 6px', borderRadius: '4px', border: '1px solid #e2e8f0', whiteSpace: 'nowrap' }}>{marriageDate}</span>}
//                             </div>
//                         )}
//                         {spouse && <Member person={spouse} relation={spouse.gender === 'Male' ? 'Husband' : 'Wife'} isSpouse={true} />}
//                     </div>

//                     {/* NEW: COLLAPSE / EXPAND BUTTON */}
//                     {hasChildren && (
//                         <div style={{ marginTop: '12px', position: 'relative', zIndex: 20 }}>
//                             <button 
//                                 onClick={(e) => toggleNode(node.id, defaultCollapsed, e)}
//                                 style={{
//                                     backgroundColor: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1',
//                                     borderRadius: '20px', padding: '4px 14px', fontSize: '11px', fontWeight: 'bold',
//                                     cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', transition: 'all 0.2s'
//                                 }}
//                             >
//                                 {isCollapsed ? `▼ Expand Branch (${node.children.length})` : '▲ Hide Branch'}
//                             </button>
//                         </div>
//                     )}

//                 </div>

//                 {/* Only render children if NOT collapsed */}
//                 {hasChildren && !isCollapsed && renderTree(node.children, depth + 1)}
//               </li>
//             );
//         })}
//       </ul>
//     );
//   };

//   return (
//     <div className="tree-wrapper" style={{ height: '100%', width: '100%', backgroundColor: '#f8fafc', position: 'relative', overflow: 'hidden' }}>
//       <TransformWrapper initialScale={0.6} minScale={0.1} maxScale={3} centerOnInit={true} wheel={{ step: 0.1 }}>
//         {({ zoomIn, zoomOut, resetTransform }) => (
//           <React.Fragment>
//             <div style={{ position: 'absolute', bottom: '20px', right: '20px', zIndex: 1000, display: 'flex', gap: '8px', backgroundColor: 'white', padding: '8px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', border: '1px solid #e2e8f0' }}>
//                 <button onClick={() => zoomIn()} style={{ padding: '6px 14px', cursor: 'pointer', border: '1px solid #cbd5e1', borderRadius: '4px', backgroundColor: '#f8fafc', fontWeight: 'bold', color: '#334155' }}>+</button>
//                 <button onClick={() => zoomOut()} style={{ padding: '6px 14px', cursor: 'pointer', border: '1px solid #cbd5e1', borderRadius: '4px', backgroundColor: '#f8fafc', fontWeight: 'bold', color: '#334155' }}>-</button>
//                 <button onClick={() => resetTransform()} style={{ padding: '6px 14px', cursor: 'pointer', border: '1px solid #cbd5e1', borderRadius: '4px', backgroundColor: '#f8fafc', fontSize: '12px', fontWeight: 'bold', color: '#334155' }}>Reset View</button>
//             </div>
//             <TransformComponent wrapperStyle={{ width: '100%', height: '100%', cursor: 'grab' }}>
//                 <div className="tree-container" style={{ minWidth: '100%', minHeight: '100%', display: 'flex', justifyContent: 'center' }}>
//                   <div className="tree" style={{ width: 'max-content', paddingTop: '140px', paddingBottom: '100px', paddingLeft: '100px', paddingRight: '100px' }}>
//                     <style>{treeStyles}</style>
//                     {treeData.length === 0 ? (
//                         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '80px', opacity: 0.6 }}><div style={{ fontSize: '40px', marginBottom: '10px' }}>🌳</div><h3 style={{ color: '#64748b', fontWeight: '500' }}>Tree is empty</h3>{isAdmin && <button onClick={() => onAddMember && onAddMember(null, false)} style={{ marginTop: '16px', backgroundColor: '#2563eb', color: 'white', padding: '8px 24px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}>Start Tree</button>}</div>
//                     ) : renderTree(treeData)}
//                   </div>
//                 </div>
//             </TransformComponent>
//           </React.Fragment>
//         )}
//       </TransformWrapper>
//     </div>
//   );
// };

// export default FamilyTree;











import React, { useState } from 'react';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const treeStyles = `
/* 1. FLEX LAYOUT */
.tree ul { padding-top: 20px; position: relative; transition: all 0.5s; display: flex; justify-content: center; }
.tree li { float: left; text-align: center; list-style-type: none; position: relative; padding: 20px 5px 0 5px; transition: all 0.5s; }

/* 2. CONNECTOR LINES (Dark Grey) */
.tree li::before, .tree li::after { content: ''; position: absolute; top: 0; right: 50%; border-top: 2px solid #64748b; width: 50%; height: 20px; z-index: 0; }
.tree li::after { right: auto; left: 50%; border-left: 2px solid #64748b; }
.tree li:only-child::after, .tree li:only-child::before { display: none; }
.tree li:only-child { padding-top: 0; }
.tree li:first-child::before, .tree li:last-child::after { border: 0 none; }
.tree li:last-child::before { border-right: 2px solid #64748b; border-radius: 0 5px 0 0; }
.tree li:first-child::after { border-radius: 5px 0 0 0; }
.tree ul ul::before { content: ''; position: absolute; top: 0; left: 50%; border-left: 2px solid #64748b; width: 0; height: 20px; }

/* 3. HOVER LOGIC FOR BIO TOOLTIP */
.member-card .bio-tooltip { visibility: hidden; opacity: 0; transition: opacity 0.2s ease-in-out; }
.member-card:hover .bio-tooltip { visibility: visible; opacity: 1; }

/* 4. ADMIN ACTIONS VISIBILITY */
.member-card .admin-actions { opacity: 0; transition: opacity 0.2s; }
.member-card:hover .admin-actions { opacity: 1; }
`;

const Member = ({ person, relation, isSpouse, hasMultipleSpouses, onAddMember, onEditMember, onDeleteMember, onRequestPhone, isAdmin }) => {
    if (!person) return null;
    const isMale = person.gender === 'Male';
    const cardStyle = {
        backgroundColor: '#ffffff', border: isMale ? '2px solid #60a5fa' : '2px solid #f472b6', 
        borderRadius: '12px', padding: '12px', width: '200px', minHeight: '160px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)', position: 'relative', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'space-between', zIndex: 10, margin: '0 auto', cursor: 'default'
    };

    return (
      <div className="member-card" style={cardStyle}>
        
        {/* BIRTH ORDER BADGE */}
        {person.birthOrder && (
            <div style={{ position: 'absolute', top: '-12px', left: '-12px', backgroundColor: isMale ? '#2563eb' : '#db2777', color: 'white', fontSize: '12px', fontWeight: 'bold', width: '26px', height: '26px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 30, border: '2px solid white', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
                {person.birthOrder}
            </div>
        )}

        {/* SPOUSE ORDER BADGE (Only shows if there are multiple spouses) */}
        {person.spouseOrder && isSpouse && hasMultipleSpouses && (
            <div style={{ position: 'absolute', top: '-12px', right: '-12px', backgroundColor: '#e11d48', color: 'white', fontSize: '11px', fontWeight: 'bold', width: '22px', height: '22px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 30, border: '2px solid white', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
                {person.spouseOrder}
            </div>
        )}

        {person.bio && (
            <div className="bio-tooltip" style={{ position: 'absolute', bottom: '100%', left: '50%', transform: 'translateX(-50%)', marginBottom: '10px', width: '220px', padding: '12px', backgroundColor: '#1e293b', color: 'white', fontSize: '12px', borderRadius: '8px', zIndex: 100, textAlign: 'left', pointerEvents: 'none', boxShadow: '0 10px 15px rgba(0,0,0,0.2)' }}>
                <div style={{ fontWeight: 'bold', borderBottom: '1px solid #475569', paddingBottom: '4px', marginBottom: '4px' }}>{person.name}</div>
                <p style={{ lineHeight: '1.4', opacity: 0.9, margin: 0 }}>{person.bio}</p>
                <div style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', borderWidth: '6px', borderStyle: 'solid', borderColor: '#1e293b transparent transparent transparent' }}></div>
            </div>
        )}

        <div style={{ position: 'absolute', top: '-10px', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#475569', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '2px 8px', borderRadius: '12px', zIndex: 20 }}>{relation}</div>

        <div style={{ width: '100%', textAlign: 'center', marginTop: '8px' }}>
            <div style={{ fontWeight: 'bold', color: isMale ? '#1e3a8a' : '#831843', marginBottom: '4px', wordWrap: 'break-word', whiteSpace: 'normal', lineHeight: '1.2', width: '100%', fontSize: '14px' }}>{person.name}</div>
            <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: '4px', fontSize: '10px', fontWeight: 'bold', backgroundColor: isMale ? '#eff6ff' : '#fdf2f8', color: isMale ? '#2563eb' : '#db2777' }}>{person.gender}</span>
            <div style={{ fontSize: '11px', color: '#64748b', marginTop: '6px' }}>
                <div style={{ whiteSpace: 'nowrap' }}>DOB {person.birthDate || '?'}</div>
                {person.deathDate && <div style={{ color: '#94a3b8' }}>D {person.deathDate}</div>}
            </div>
            {person.email && <div style={{ fontSize: '10px', color: '#64748b', marginTop: '4px', wordBreak: 'break-all' }} title={person.email}>📧 {person.email}</div>}
            {person.website && <div style={{ fontSize: '10px', color: '#3b82f6', marginTop: '2px' }}>🔗 <a href={person.website} target="_blank" rel="noopener noreferrer" style={{color: 'inherit'}}>Website</a></div>}
        </div>

        <div style={{ width: '100%', marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #f1f5f9' }}>
            {person.phoneNumber === 'HIDDEN' ? (
                <button onClick={(e) => { e.stopPropagation(); if(onRequestPhone) onRequestPhone(person); }} style={{ width: '100%', fontSize: '10px', fontWeight: 'bold', color: '#2563eb', backgroundColor: '#eff6ff', border: '1px solid #dbeafe', padding: '6px', borderRadius: '4px', cursor: 'pointer' }}>Request Contact</button>
            ) : <div style={{ fontSize: '11px', color: '#475569' }}>📞 {person.phoneNumber || 'N/A'}</div>}
        </div>

        {(onAddMember || isAdmin) && (
            <div className="admin-actions" style={{ display: 'flex', gap: '4px', justifyContent: 'center', marginTop: '6px' }}>
                {isAdmin ? (
                    <>
                        <button onClick={(e) => { e.stopPropagation(); onEditMember(person); }} style={{ fontSize: '10px', color: '#3b82f6', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>Edit</button>
                        <button onClick={(e) => { e.stopPropagation(); if(window.confirm('Delete?')) onDeleteMember(person.id); }} style={{ fontSize: '10px', color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>Del</button>
                    </>
                ) : null}
                {onAddMember && <button onClick={(e) => { e.stopPropagation(); onAddMember(person, 'child'); }} style={{ fontSize: '9px', backgroundColor: '#f1f5f9', border: '1px solid #cbd5e1', padding: '2px 6px', borderRadius: '4px', cursor: 'pointer' }}>+</button>}
            </div>
        )}
      </div>
    );
};

// NEW: TreeNode perfectly handles Collapsing Branches AND Multiple Spouses!
const TreeNode = ({ node, depth, members, onAddMember, onEditMember, onDeleteMember, onRequestPhone, isAdmin, collapsedState, toggleNode }) => {
    const [activeSpouseIdx, setActiveSpouseIdx] = useState(0);

    let spouses = members.filter(m => m.spouseId === node.id || node.spouseId === m.id);
    spouses = spouses.filter((v, i, a) => a.findIndex(t => t.id === v.id) === i && v.id !== node.id);
    spouses.sort((a, b) => (a.spouseOrder || 99) - (b.spouseOrder || 99));

    const spouse = spouses.length > 0 ? spouses[activeSpouseIdx] : null;

    let primaryRelation = 'Head';
    if (node.fatherId || node.motherId) primaryRelation = node.gender === 'Male' ? 'Son' : 'Daughter';
    else if (spouse) primaryRelation = node.gender === 'Male' ? 'Husband' : 'Wife';
    
    const marriageDate = node.marriageDate || (spouse ? spouse.marriageDate : null);
    const hasChildren = node.children && node.children.length > 0;
    
    // Default collapse nodes at depth 1 and below
    const defaultCollapsed = depth >= 1; 
    const isCollapsed = collapsedState[node.id] !== undefined ? collapsedState[node.id] : defaultCollapsed;

    return (
        <li key={node.id}>
            <div style={{ display: 'inline-block', verticalAlign: 'top', textAlign: 'center' }}>
                {!node.fatherId && !node.motherId && onAddMember && (
                    <div style={{ marginBottom: '20px' }}>
                        <button onClick={(e) => { e.stopPropagation(); onAddMember(node, 'parent'); }} style={{ backgroundColor: '#334155', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '6px 16px', borderRadius: '20px', border: 'none', cursor: 'pointer' }}>{isAdmin ? '+ Add Parents' : 'Request Parents'}</button>
                    </div>
                )}
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '0px' }}>
                    <Member person={node} relation={primaryRelation} isSpouse={false} onAddMember={onAddMember} onEditMember={onEditMember} onDeleteMember={onDeleteMember} onRequestPhone={onRequestPhone} isAdmin={isAdmin} />
                    
                    {spouse && (
                        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 10px', paddingTop: '40px' }}>
                            <div style={{ position: 'absolute', top: '55px', width: '100%', height: '2px', backgroundColor: '#fda4af', zIndex: 0 }}></div>
                            
                            {/* MULTIPLE SPOUSES TOGGLE */}
                            {spouses.length > 1 && (
                                <button 
                                    onClick={(e) => { e.stopPropagation(); setActiveSpouseIdx((prev) => (prev + 1) % spouses.length); }}
                                    style={{ position: 'absolute', top: '25px', backgroundColor: '#fff', border: '1px solid #fecdd3', fontSize: '9px', padding: '2px 8px', borderRadius: '10px', cursor: 'pointer', zIndex: 20, color: '#e11d48', fontWeight: 'bold', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                                >
                                    ⟳ Spouse {activeSpouseIdx + 1}/{spouses.length}
                                </button>
                            )}

                            <div style={{ backgroundColor: 'white', border: '1px solid #fecdd3', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#f43f5e', fontSize: '12px', zIndex: 10, marginBottom: '4px' }}>♥</div>
                            {marriageDate && <span style={{ fontSize: '9px', color: '#64748b', backgroundColor: 'white', padding: '2px 6px', borderRadius: '4px', border: '1px solid #e2e8f0', whiteSpace: 'nowrap' }}>{marriageDate}</span>}
                        </div>
                    )}
                    {spouse && <Member person={spouse} relation={spouse.gender === 'Male' ? 'Husband' : 'Wife'} isSpouse={true} hasMultipleSpouses={spouses.length > 1} onAddMember={onAddMember} onEditMember={onEditMember} onDeleteMember={onDeleteMember} onRequestPhone={onRequestPhone} isAdmin={isAdmin} />}
                </div>

                {/* EXPAND/REDUCE BUTTON */}
                {hasChildren && (
                    <div style={{ marginTop: '12px', position: 'relative', zIndex: 20 }}>
                        <button 
                            onClick={(e) => toggleNode(node.id, defaultCollapsed, e)}
                            style={{
                                backgroundColor: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1',
                                borderRadius: '20px', padding: '4px 14px', fontSize: '11px', fontWeight: 'bold',
                                cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', transition: 'all 0.2s'
                            }}
                        >
                            {isCollapsed ? `▼ Expand Branch (${node.children.length})` : '▲ Hide Branch'}
                        </button>
                    </div>
                )}
            </div>

            {/* ONLY RENDER CHILDREN IF BRANCH IS EXPANDED */}
            {hasChildren && !isCollapsed && (
                <ul>
                    {node.children.map((child) => (
                        <TreeNode key={child.id} node={child} depth={depth + 1} members={members} onAddMember={onAddMember} onEditMember={onEditMember} onDeleteMember={onDeleteMember} onRequestPhone={onRequestPhone} isAdmin={isAdmin} collapsedState={collapsedState} toggleNode={toggleNode} />
                    ))}
                </ul>
            )}
        </li>
    );
};

const FamilyTree = ({ members = [], onAddMember, onEditMember, onDeleteMember, onRequestPhone, isAdmin }) => {
  const [collapsedState, setCollapsedState] = useState({});

  if (!members || !Array.isArray(members)) return <div style={{padding: '40px', textAlign: 'center', color: '#666'}}>Loading Family Tree...</div>;

  const buildTree = () => {
    try {
      const memberMap = {};
      members.forEach(m => { if (m && m.id) memberMap[m.id] = { ...m, children: [] }; });
      const roots = [];
      members.forEach(m => {
        if (!m || !m.id) return;
        const node = memberMap[m.id];
        const father = m.fatherId ? memberMap[m.fatherId] : null;
        const mother = m.motherId ? memberMap[m.motherId] : null;

        if (father && mother) {
             if (mother.fatherId || mother.motherId) mother.children.push(node);
             else if (father.fatherId || father.motherId) father.children.push(node);
             else father.children.push(node);
        } else if (father) father.children.push(node);
        else if (mother) mother.children.push(node);
        else {
            if (m.spouseId) {
                 const spouse = memberMap[m.spouseId];
                 if (!spouse) roots.push(node); 
                 else if (!spouse.fatherId && !spouse.motherId) {
                    if (m.gender === 'Male') roots.push(node);
                 }
            } else roots.push(node);
        }
      });
      return roots;
    } catch (err) { return []; }
  };

  const treeData = buildTree();

  const toggleNode = (nodeId, currentDefaultState, e) => {
    e.stopPropagation();
    setCollapsedState(prev => ({ ...prev, [nodeId]: prev[nodeId] === undefined ? !currentDefaultState : !prev[nodeId] }));
  };

  return (
    <div className="tree-wrapper" style={{ height: '100%', width: '100%', backgroundColor: '#f8fafc', position: 'relative', overflow: 'hidden' }}>
      <TransformWrapper initialScale={0.6} minScale={0.1} maxScale={3} centerOnInit={true} wheel={{ step: 0.1 }}>
        {({ zoomIn, zoomOut, resetTransform }) => (
          <React.Fragment>
            <div style={{ position: 'absolute', bottom: '20px', right: '20px', zIndex: 1000, display: 'flex', gap: '8px', backgroundColor: 'white', padding: '8px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', border: '1px solid #e2e8f0' }}>
                <button onClick={() => zoomIn()} style={{ padding: '6px 14px', cursor: 'pointer', border: '1px solid #cbd5e1', borderRadius: '4px', backgroundColor: '#f8fafc', fontWeight: 'bold', color: '#334155' }}>+</button>
                <button onClick={() => zoomOut()} style={{ padding: '6px 14px', cursor: 'pointer', border: '1px solid #cbd5e1', borderRadius: '4px', backgroundColor: '#f8fafc', fontWeight: 'bold', color: '#334155' }}>-</button>
                <button onClick={() => resetTransform()} style={{ padding: '6px 14px', cursor: 'pointer', border: '1px solid #cbd5e1', borderRadius: '4px', backgroundColor: '#f8fafc', fontSize: '12px', fontWeight: 'bold', color: '#334155' }}>Reset View</button>
            </div>
            <TransformComponent wrapperStyle={{ width: '100%', height: '100%', cursor: 'grab' }}>
                <div className="tree-container" style={{ minWidth: '100%', minHeight: '100%', display: 'flex', justifyContent: 'center' }}>
                  <div className="tree" style={{ width: 'max-content', paddingTop: '140px', paddingBottom: '100px', paddingLeft: '100px', paddingRight: '100px' }}>
                    <style>{treeStyles}</style>
                    {treeData.length === 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '80px', opacity: 0.6 }}><div style={{ fontSize: '40px', marginBottom: '10px' }}>🌳</div><h3 style={{ color: '#64748b', fontWeight: '500' }}>Tree is empty</h3>{isAdmin && <button onClick={() => onAddMember && onAddMember(null, false)} style={{ marginTop: '16px', backgroundColor: '#2563eb', color: 'white', padding: '8px 24px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}>Start Tree</button>}</div>
                    ) : (
                        <ul>
                            {treeData.map(node => (
                                <TreeNode key={node.id} node={node} depth={0} members={members} onAddMember={onAddMember} onEditMember={onEditMember} onDeleteMember={onDeleteMember} onRequestPhone={onRequestPhone} isAdmin={isAdmin} collapsedState={collapsedState} toggleNode={toggleNode} />
                            ))}
                        </ul>
                    )}
                  </div>
                </div>
            </TransformComponent>
          </React.Fragment>
        )}
      </TransformWrapper>
    </div>
  );
};

export default FamilyTree;